export default "__VITE_ASSET__834198c7__"